import React, { memo } from 'react';
import SearchBar from '@common/components/search-bar';
import PredicateFiltersGroup from './predicate-filters-group';
import { combineClassNames } from '@common/utils/combineClassNames';

const FiltersToolbar = memo(({
  predicates,
  setPredicates,
  organisation,
  searchEnabled = true,
  onSearch,
  searchPlaceholder,
  debounce,
  children,
  defaultSearchValue,
  className
}: any) => {
  return (
    <div className={combineClassNames('PredicatesFilter__Filters', className)}>
      {
        searchEnabled ?
          <SearchBar
            onSearch={onSearch}
            debounce={debounce}
            placeholder={searchPlaceholder}
            defaultValue={defaultSearchValue}
          /> :
          null
      }
      <PredicateFiltersGroup
        predicates={predicates}
        setPredicates={setPredicates}
        organisation={organisation}
      />
      {children}
    </div>
  );
});

export default FiltersToolbar;
